var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMagicStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.59 20.75 8.83 17.9c-.17-.28-.69-.55-1.01-.53l-3.34.17c-2 .1-2.7-.73-2.95-1.23s-.47-1.57.83-3.09l1.98-2.3c.2-.24.31-.76.22-1.06L3.55 6.63c-.51-1.62.06-2.49.44-2.87.38-.38 1.26-.93 2.88-.39l2.95.97c.27.09.77.01 1-.15l3.08-2.22c1.41-1.02 2.43-.75 2.9-.5.47.25 1.27.93 1.24 2.67l-.07 3.79c-.01.28.22.74.44.91l2.48 1.88c1.35 1.03 1.4 2.06 1.31 2.59-.09.53-.49 1.49-2.11 1.99l-3.23 1.01c-.3.09-.67.48-.75.78l-.77 2.94c-.51 1.93-1.51 2.36-2.07 2.44-.07.02-.16.03-.26.03-.6 0-1.53-.29-2.42-1.75zm-.49-3.64 1.76 2.85c.5.82.95 1.07 1.19 1.03.23-.03.59-.41.84-1.33l.77-2.94c.21-.8.96-1.59 1.75-1.83l3.23-1.01c.62-.19 1.02-.5 1.08-.82.06-.32-.22-.74-.74-1.14l-2.48-1.88c-.61-.46-1.05-1.38-1.04-2.14l.07-3.79c.01-.67-.15-1.17-.44-1.32-.29-.15-.78 0-1.33.39L11.68 5.4c-.61.44-1.62.6-2.35.36l-2.95-.97c-.62-.2-1.12-.19-1.35.04-.23.23-.25.73-.06 1.35l1.01 3.23c.25.79.03 1.86-.51 2.48l-1.98 2.3c-.63.73-.73 1.24-.62 1.45.1.21.58.44 1.53.39l3.34-.17c.04.01.08.01.11.01.86 0 1.81.52 2.25 1.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.38 22.53-3.03-3.03a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.03 3.03c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMagicStar);
export default __webpack_public_path__ + "static/media/vuesax-outline-magic-star.213c4d44c792f03f09e7a644d9cac3f3.svg";
export { ForwardRef as ReactComponent };